"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function keyForInvalidAddressTypeOmission(type) {
  return ![type, (0, _lodash.get)(type, 'value')].includes('ours') ? null : 'addressType';
}
function keyForInvalidDistanceOmission(distance) {
  return ['', 'any'].includes(distance) || (0, _lodash.isEmpty)(distance) ? 'distance' : null;
}
var createFilterTrackingObject = function createFilterTrackingObject(filters) {
  if ((0, _lodash.isEmpty)(filters)) {
    return [];
  }
  var trackingFilters = (0, _lodash.uuOmit)(filters, ['address', keyForInvalidDistanceOmission(filters.distance), keyForInvalidAddressTypeOmission(filters.addressType), 'includeHomeGroups', 'networks', 'contextAction']);
  return (0, _lodash.keys)((0, _lodash.uuCompactArrayOrObject)(trackingFilters));
};
var _default = exports["default"] = createFilterTrackingObject;